export default "__VITE_ASSET__f2e0fdfd__"